export const CanonicalUrlType = {
  REL_CANONICAL: 'link[rel="canonical"]',
  OG_URL: 'meta[property="og:url"]',
  TWITTER_URL: 'meta[name="twitter:url"]',
  META_REFRESH: 'meta[http-equiv="refresh"]',
  AL_WEB_URL: 'meta[property="al:web:url"]',
}

export const orderedCanonicalUrlTypes = [
  CanonicalUrlType.REL_CANONICAL,
  CanonicalUrlType.OG_URL,
  CanonicalUrlType.TWITTER_URL,
  CanonicalUrlType.AL_WEB_URL,
  CanonicalUrlType.META_REFRESH,
]

const canonicalCollectors = {
  [CanonicalUrlType.REL_CANONICAL]: (el) =>
    new URL(el.href, document.baseURI).href,
  [CanonicalUrlType.OG_URL]: (el) => new URL(el.content, document.baseURI).href,
  [CanonicalUrlType.TWITTER_URL]: (el) =>
    new URL(el.content, document.baseURI).href,
  [CanonicalUrlType.META_REFRESH]: (el) => {
    const match = /url=(.+)/i.exec(el.content || '')
    if (match) return new URL(match[1].trim(), document.baseURI).href
  },
  [CanonicalUrlType.AL_WEB_URL]: (el) =>
    new URL(el.content, document.baseURI).href,
}

/**
 * Collect all possible canonical-ish URLs from the document.
 * @returns {string[]} array of absolute URLs
 */
export function collectCanonicalUrls() {
  const result = {}
  const types = Object.keys(canonicalCollectors)
  for (let type of types) {
    const qResult = document.querySelectorAll(type)
    for (const el of qResult) {
      try {
        result[type] = canonicalCollectors[type](el)
        if (result[type]) break
      } catch (e) {
        console.warn('Error collecting canonical URL from', el, e)
      }
    }
  }
  return result
}
